const statusDialogConstatnsAr = {
  publishBlogTitle: 'منشور',
  publishBlogContent: 'هل أنت متأكد أنك تريد نشر هذا المقال؟',
  unPublishBlogTitle: 'إلغاء النشر',
  unPublishBlogContent: 'هل أنت متأكد أنك تريد إلغاء نشر هذا المقال؟',
  dialogConfirmButton: 'نعم',
  dialogCancelButton: 'لا',
};
export default statusDialogConstatnsAr;
